import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { useAxiosInstance } from "@iloq/shared-react/use-axios-instance.hook";
import { IBulletin, IApiBulletin } from "@iloq/shared/";
import { bulletinDataMapper } from "../bulletin-data-mapper";
import { useIntl } from "react-intl";

export const GET_PARTNER_BULLETINS_QUERY_KEY = "getPartnerBulletins";

export function useGetPartnerBulletinsQuery(countryCode: string): UseQueryResult<IBulletin[]> {
  const axiosInstance = useAxiosInstance();
  const { locale, formatMessage } = useIntl();

  return useQuery({
    queryKey: [GET_PARTNER_BULLETINS_QUERY_KEY],
    staleTime: 1000 * 60 * 60 * 8, // 8 hours (daily updates, since bulletins seem to be published only 1-2 a month)
    queryFn: async (): Promise<IApiBulletin[]> => {
      const response = await axiosInstance.get<IApiBulletin[]>(
        `/api/v1/news/bulletin/${countryCode}`,
      );
      return response.data;
    },
    select: (data): IBulletin[] => bulletinDataMapper(data, locale, formatMessage),
  });
}
